import MasterTab from 'src/components/Layouts/MasterTab.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import DistancingTypes from 'src/views/Pages/Dashboard/Sowing/DistancingType/DistancingTypes.vue';
import SowingCatch from 'src/views/Pages/Dashboard/Sowing/SowingCatch/Catch.vue';
const SowingsRoutes = {
    path: 'sowing',
    name: 'sowing.sowing',
    component: MasterTab,
  props: { reference: 'sowingsTabs' },
  children: [
    {
      path: 'distancingtype',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sowing.distancing_type',
          component: DistancingTypes,
          meta: {
            prefix_permission: 'sowing_distancingtype',
          },
        },
      ]
    },
    {
      path: 'sowingcatch',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sowing.sowing_catch',
          component: SowingCatch,
          meta: {
            prefix_permission: 'sowing_sowingcatch',
          },
        },
      ]
    },
  ]
}

export default SowingsRoutes;